import httpClient, {ApplicationJson, POST, PUT, GET, DELETE} from '@/apis/base/httpclient';
import commonFn from '@/commons/commonFunction';

export default class BaseAPI {
  baseUrl = '';
  controllerName = '';
  apiName = '';

  // khởi tạo ApiUrl
  // created by NDQUAN 20/08/2019
  // API được khởi tạo dựa trên apiName
  initAPI() {
    if (this.apiName) {
      this.baseUrl = window._apis[this.apiName] + '/' + this.controllerName;
    }
  }

  // Build api url
  // CreatedBy NDQUAN 20/08/2019
  getAPIUrl() {
    // Khi base url chưa khởi tạo
    if (this.baseUrl == '') {
      this.initAPI();
    }

    // Nếu có truyền thêm argument thì nó khởi tạo thêm url
    if (arguments && arguments.length > 0) {
      return commonFn.combineUrl(this.baseUrl, ...arguments);
    }

    return this.baseUrl;
  }

  /**
   * config: AxiosRequestConfig
   * @param config: {
   * url?: string;
   * method?: string;
   * baseURL?: string;
   * transformRequest?: AxiosTransformer | AxiosTransformer[];
   * transformResponse?: AxiosTransformer | AxiosTransformer[];
   * headers?: any;
   * params?: any;
   * paramsSerializer?: (params: any) => string;
   * data?: any;
   * timeout?: number;
   * withCredentials?: boolean;
   * adapter?: AxiosAdapter;
   * auth?: AxiosBasicCredentials;
   * responseType?: string;
   * xsrfCookieName?: string;
   * xsrfHeaderName?: string;
   * onUploadProgress?: (progressEvent: any) => void;
   * onDownloadProgress?: (progressEvent: any) => void;
   * maxContentLength?: number;
   * validateStatus?: (status: number) => boolean;
   * maxRedirects?: number;
   * httpAgent?: any;
   * httpsAgent?: any;
   * proxy?: AxiosProxyConfig | false;
   * cancelToken?: CancelToken;
   * }
   * @param isShowLoading: có cho loading hay không, hiển thị loading cho người dùng
   * @param isCancelRequest: có cho phép hủy request cùng url và method hay không
   * @param contenType: application/json, application/x-www-form-urlencoded, multipart/form-data
   */
  async postAsync(config, isShowLoading = false, isCancelRequest = true, contenType = ApplicationJson) {
    return await httpClient.requestAsync(config, POST, isShowLoading, isCancelRequest, contenType);
  }

  /**
   * config: AxiosRequestConfig
   * @param config: {
   * url?: string;
   * method?: string;
   * baseURL?: string;
   * transformRequest?: AxiosTransformer | AxiosTransformer[];
   * transformResponse?: AxiosTransformer | AxiosTransformer[];
   * headers?: any;
   * params?: any;
   * paramsSerializer?: (params: any) => string;
   * data?: any;
   * timeout?: number;
   * withCredentials?: boolean;
   * adapter?: AxiosAdapter;
   * auth?: AxiosBasicCredentials;
   * responseType?: string;
   * xsrfCookieName?: string;
   * xsrfHeaderName?: string;
   * onUploadProgress?: (progressEvent: any) => void;
   * onDownloadProgress?: (progressEvent: any) => void;
   * maxContentLength?: number;
   * validateStatus?: (status: number) => boolean;
   * maxRedirects?: number;
   * httpAgent?: any;
   * httpsAgent?: any;
   * proxy?: AxiosProxyConfig | false;
   * cancelToken?: CancelToken;
   * }
   * @param isShowLoading: có cho loading hay không, hiển thị loading cho người dùng
   * @param isCancelRequest: có cho phép hủy request cùng url và method hay không
   * @param contenType: application/json, application/x-www-form-urlencoded, multipart/form-data
   */
  async putAsync(config, isShowLoading = false, isCancelRequest = true, contenType = ApplicationJson) {
    return await httpClient.requestAsync(config, PUT, isShowLoading, isCancelRequest, contenType);
  }

  /**
   * config: AxiosRequestConfig
   * @param config: {
   * url?: string;
   * method?: string;
   * baseURL?: string;
   * transformRequest?: AxiosTransformer | AxiosTransformer[];
   * transformResponse?: AxiosTransformer | AxiosTransformer[];
   * headers?: any;
   * params?: any;
   * paramsSerializer?: (params: any) => string;
   * data?: any;
   * timeout?: number;
   * withCredentials?: boolean;
   * adapter?: AxiosAdapter;
   * auth?: AxiosBasicCredentials;
   * responseType?: string;
   * xsrfCookieName?: string;
   * xsrfHeaderName?: string;
   * onUploadProgress?: (progressEvent: any) => void;
   * onDownloadProgress?: (progressEvent: any) => void;
   * maxContentLength?: number;
   * validateStatus?: (status: number) => boolean;
   * maxRedirects?: number;
   * httpAgent?: any;
   * httpsAgent?: any;
   * proxy?: AxiosProxyConfig | false;
   * cancelToken?: CancelToken;
   * }
   * @param isShowLoading: có cho loading hay không, hiển thị loading cho người dùng
   * @param isCancelRequest: có cho phép hủy request cùng url và method hay không
   * @param contenType: application/json, application/x-www-form-urlencoded, multipart/form-data
   */
  async getAsync(config, isShowLoading = false, isCancelRequest = true, contenType = ApplicationJson) {
    return await httpClient.requestAsync(config, GET, isShowLoading, isCancelRequest, contenType);
  }

  /**
   * config: AxiosRequestConfig
   * @param config: {
   * url?: string;
   * method?: string;
   * baseURL?: string;
   * transformRequest?: AxiosTransformer | AxiosTransformer[];
   * transformResponse?: AxiosTransformer | AxiosTransformer[];
   * headers?: any;
   * params?: any;
   * paramsSerializer?: (params: any) => string;
   * data?: any;
   * timeout?: number;
   * withCredentials?: boolean;
   * adapter?: AxiosAdapter;
   * auth?: AxiosBasicCredentials;
   * responseType?: string;
   * xsrfCookieName?: string;
   * xsrfHeaderName?: string;
   * onUploadProgress?: (progressEvent: any) => void;
   * onDownloadProgress?: (progressEvent: any) => void;
   * maxContentLength?: number;
   * validateStatus?: (status: number) => boolean;
   * maxRedirects?: number;
   * httpAgent?: any;
   * httpsAgent?: any;
   * proxy?: AxiosProxyConfig | false;
   * cancelToken?: CancelToken;
   * }
   * @param isShowLoading: có cho loading hay không, hiển thị loading cho người dùng
   * @param isCancelRequest: có cho phép hủy request cùng url và method hay không
   * @param contenType: application/json, application/x-www-form-urlencoded, multipart/form-data
   */
  async deleteAsync(config, isShowLoading = false, isCancelRequest = true, contenType = ApplicationJson) {
    return await httpClient.requestAsync(config, DELETE, isShowLoading, isCancelRequest, contenType);
  }

  /**
   * Lấy dữ liệu danh sách phân trang
   */
  getPaging(payload) {
    const request = {
      url: this.getAPIUrl() + '/Paging',
      data: payload,
    };

    return httpClient.postAsync(request);
  }

  /**
   * Lấy summary danh sách phân trang
   */
  getPagingSummary(payload) {
    const request = {
      url: this.getAPIUrl() + '/Paging/Summary',
      data: payload,
    };

    return httpClient.postAsync(request);
  }

  /**
   * Lấy dữ liệu danh sách full
   */
  getItems(payload) {
    const request = {
      url: this.getAPIUrl(),
      data: payload,
    };

    return httpClient.getAsync(request);
  }
  /**
   * Lấy dữ liệu danh sách tree
   */
  getTree(payload) {
    const request = {
      url: this.getAPIUrl() + '/Trees',
      data: payload,
    };

    return httpClient.getAsync(request);
  }

  /**
   * Lấy dữ liệu danh sách theo ids, ids là chuỗi phân cách bởi dấu ,
   * HTHIEP 13.07.2022
   */
  getDataByIds(payload) {
    const request = {
      url: this.getAPIUrl() + '/ids',
      data: payload,
    };

    return httpClient.getAsync(request);
  }

  /**
   * Lấy bản ghi mặc định khi thêm mới
   */
  getNew(payload) {
    const request = {
      url: this.getAPIUrl() + '/DefaultData',
      data: payload,
    };

    return httpClient.getAsync(request);
  }

  getAutoID(payload) {
    const request = {
      url: this.getAPIUrl() + '/getAutoID',
      data: payload,
    };

    return httpClient.getAsync(request);
  }

  /**
   * Lấy bản ghi mặc định khi thêm mới
   */
  getEdit(payload) {
    const request = {
      url: [this.getAPIUrl(), payload.id].join('/'),
    };

    return httpClient.getAsync(request);
  }
  /**
   * Lấy bản ghi nhân bản
   */
  getDuplicate(payload) {
    const request = {
      url: this.getAPIUrl() + '/Duplicate',
      data: payload,
    };

    return httpClient.getAsync(request);
  }

  /**
   * Thêm mới
   */
  insert(payload) {
    const request = {
      url: this.getAPIUrl(),
      data: payload,
    };
    return httpClient.postAsync(request, true);
  }

  /**
   * Thêm mới
   */
  insertMulti(payload) {
    const request = {
      url: this.getAPIUrl() + '/batch',
      data: payload,
    };
    return httpClient.postAsync(request, true);
  }

  /**
   * Cập nhật
   */
  update(payload) {
    const request = {
      url: this.getAPIUrl(),
      data: payload,
    };
    return httpClient.putAsync(request, true);
  }

  /**
   * Xóa
   */
  delete(payload) {
    const request = {
      url: this.getAPIUrl(),
      data: payload,
    };
    return httpClient.deleteAsync(request, true);
  }

  /**
   * Lấy dữ liệu combobox load paging
   */
  getComboboxPaging(payload) {
    const param = {...payload};

    // xử lý tham số trước khi request load dữ liệu
    commonFn.processComboboxParamRequest(param);

    const request = {
      url: this.getAPIUrl() + '/Combobox',
      data: param,
    };

    return httpClient.postAsync(request);
  }

  /**
   * Chuyển dữ liệu dữu liệu danh mục
   */
  UpdateTranferData(payload) {
    const request = {
      url: this.getAPIUrl() + '/tranferData',
      data: payload,
    };
    return httpClient.postAsync(request, true);
  }

  /**
   * Get data BeforeData
   * BQDIEP 20/03/2024
   */
  getBeforeData(payload) {
    const request = {
      url: this.getAPIUrl() + '/BeforeData',
      data: payload,
    };
    return httpClient.postAsync(request, true);
  }
  /**
   * Xóa data BeforeData
   * PTTAM2
   */
  deleteBeforeData(payload) {
    const request = {
      url: this.getAPIUrl() + '/BeforeData',
      data: payload,
    };
    return httpClient.deleteAsync(request, true);
  }
}
